export default __webpack_public_path__ + "static/media/it-server.3efea437.gif";